/**
 * Calculate age from date of birth string in format yyyy-MM-dd
 * @param dateOfBirth - Date string in format "yyyy-MM-dd"
 * @returns Age in years
 */
export const calculateAge = (dateOfBirth: string): number => {
  if (!dateOfBirth) return 0;

  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  // Check if the date is valid
  if (isNaN(birthDate.getTime())) {
    console.warn('Invalid date of birth provided:', dateOfBirth);
    return 0;
  }

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // If birthday hasn't occurred this year yet, subtract 1
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return Math.max(0, age); // Ensure age is not negative
};
